import { Component, OnInit } from '@angular/core';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { DataService } from 'src/app/data.service';
import { ImageItem, GalleryItem } from '@ngx-gallery/core';
import { ToastrService } from 'ngx-toastr';
import { Lightbox } from '@ngx-gallery/lightbox';
import { DownloadService } from 'src/app/_services/download.service';
import { Observable } from 'rxjs';
import { Download } from 'src/app/_helpers/download';
import { DownloadsService } from '../downloads.service';

@Component({
  selector: 'app-download-modal',
  templateUrl: './download-modal.component.html',
  styleUrls: ['./download-modal.component.scss']
})
export class DownloadModalComponent implements OnInit {

  data;
  images: GalleryItem[];

  download$: Observable<Download>;

  constructor(
    private readonly ngxSmartModalService: NgxSmartModalService,
    private readonly toastrService: ToastrService,
    private lightbox: Lightbox,
    private downloadsService: DownloadsService
  ) { }

  copyToClipboard(item) {
    document.addEventListener('copy', (e: ClipboardEvent) => {
      e.clipboardData.setData('text/plain', (item));
      e.preventDefault();
      document.removeEventListener('copy', null);
    });
    document.execCommand('copy');
    this.toastrService.info('Tekst został skopiowany do schowka!');
  }

  ngOnInit() {
    this.data = this.ngxSmartModalService.getTopOpenedModal().getData();
    const images = [];
    images.push(new ImageItem({ src: this.data.image, thumb: this.data.image }));
    this.data.files.forEach(file => {
        if (file.preview_image) {
          images.push(new ImageItem({ src: file.preview_image, thumb: file.preview_image }));
        }
      });
    this.images = images;
  }

  downloadZipFile() {
    this.downloadsService.newDownload(`/salonexpert-business/download/${this.data.slug}/zip`, `${this.data.name}`, 'paczka');
  }

  downloadFileId(id, file) {
    // console.log(fileName);
    const name = (file.description && file.description != 'null') ? file.description : (file.path.split('.').pop() );
    this.downloadsService.newDownload(`/salonexpert-business/download/${id}/file`, `${this.data.name}`, name);
  }

}
